import { render, staticRenderFns } from "./CompanyBudget.vue?vue&type=template&id=cf2303b6&"
import script from "./CompanyBudget.vue?vue&type=script&lang=js&"
export * from "./CompanyBudget.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBudget.vue?vue&type=style&index=0&id=cf2303b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports